import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import ArtistContainer from '@/components/partials/Artistcontainer/ArtistContainer';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';
import { BaseFormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';
import { IArtist } from '@/data/models/artist';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'errorBanner'
  | 'trackData'
  | 'baseMixedTrack'
  | 'handleArtist'
  | 'areNewMultipleTracks'
  | 'isMultipleTrack'
  | 'fieldHasErrors'
  | 'findErrorMessage'
> &
  BaseFormGroupProps;

export default function TrackArtistFormGroup({
  errorBanner,
  trackData,
  baseMixedTrack,
  readonly,
  disabled,
  handleArtist,
  areNewMultipleTracks,
  isMultipleTrack,
  fieldHasErrors,
  findErrorMessage,
}: Props) {
  const { t } = useTranslation();
  const [artistTooltipKey, setArtistTooltipKey] = useState(
    'tooltip.track.artistName'
  );

  const artists = !isMultipleTrack
    ? trackData.artists
    : baseMixedTrack?.artists?.value;

  const hasRequiredErrors =
    !!errorBanner &&
    !readonly &&
    (!artists ||
      artists.length === 0 ||
      artists.some((a: any) => {
        const artistData = a?.value !== undefined ? a.value : a;
        return !artistData || !artistData.name || !artistData.performerRole;
      }));
  const hasMetadataConflictErrors =
    !isMultipleTrack &&
    Array.isArray(artists) &&
    artists.some((_, index) => fieldHasErrors(`Artist.${index + 1}`));
  const hasErrors = hasRequiredErrors || hasMetadataConflictErrors;

  return (
    <>
      {!readonly ? (
        <FormGroupWithTooltip
          tooltipKey={artistTooltipKey}
          hasErrors={hasErrors}
          containerWidth={
            artistTooltipKey === 'tooltip.track.artistRole' ? 'small' : 'medium'
          }
        >
          <label htmlFor="artist" className="col-sm-3 form-label">
            {t('track.artist')}
          </label>

          <div className="col-sm-6 product-artist">
            <ArtistContainer
              errorBanner={errorBanner}
              artist={artists}
              originalArtist={baseMixedTrack?.artists?.originalValue}
              handleArtist={handleArtist}
              disabled={disabled}
              multiTrack={isMultipleTrack}
              showChangeIndicator={!areNewMultipleTracks}
              onFocusName={() =>
                setArtistTooltipKey('tooltip.track.artistName')
              }
              onFocusRole={() =>
                setArtistTooltipKey('tooltip.track.artistRole')
              }
              artistHasErrors={(index) =>
                !isMultipleTrack && fieldHasErrors(`Artist.${index + 1}`)
              }
              findArtistErrorMessage={(index) =>
                !isMultipleTrack ? findErrorMessage(`Artist.${index + 1}`) : ''
              }
            />
          </div>
        </FormGroupWithTooltip>
      ) : (
        <ReadOnlyField
          id={'artist'}
          labelTitle={t('product.editProduct.artists')}
          mode={'objectValueTypeList'}
          value={(artists as IArtist[])?.map((a) => ({
            name: a.name,
            role: a.performerRole,
          }))}
        ></ReadOnlyField>
      )}
    </>
  );
}
